<template>
  <div class="user-operate" :class="wrapperClass">
    <!-- 已登录 -->
    <div v-if="getToken" class="userinfo">
      <p class="username" :title="getUsername">
        <i class="icon el-icon-user" v-if="isMobile"></i>
        <span>{{ getUsername }}</span>
      </p>
      <p class="line">|</p>
      <el-button type="text" class="logout-btn" @click="logout">退出</el-button>
    </div>
    <!-- 未登录 -->
    <div v-else class="base-oper">
      <router-link class="link" :to="{ name: 'login' }">登录</router-link>
      |
      <router-link class="link" :to="{ name: 'registerEnterprise' }"
        >注册</router-link
      >
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import LocalStorage from "@/libs/localStorage";
import { gotoIndex } from "@/libs/tools";

export default {
  computed: {
    ...mapGetters(["getToken", "getAvatar", "getUsername", "isMobile"]),
    wrapperClass() {
      return `user-operate__${this.isMobile ? "vertical" : "horizontal"}`;
    }
  },
  methods: {
    ...mapMutations(["clearLocalStorage"]),

    logout() {
      this.$request.account_logout().then(res => {
        if (res.code === 0) {
          LocalStorage.clear();
          this.clearLocalStorage();
          gotoIndex();
          this.$message.success("退出成功");
        } else {
          this.$message.error(res.message);
        }
      });
    },
  }
};
</script>

<style lang="scss">
@import "./user.scss";
</style>
